import { createSelector } from 'reselect';

const isChannelBeingWatched = (watchedChannelId, currentId) => watchedChannelId === currentId;

export default createSelector(
  state => state.elements.ChatPanel.watchedChannel_id,
  state => state.elements.ChannelsPanel.currentId,
  isChannelBeingWatched,
);
